import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiBell, FiAlertTriangle, FiTrash2, FiUserCheck } = FiIcons;

// Palabras prohibidas para demostración
const FORBIDDEN_WORDS = ['estafa', 'fraude', 'insulto', 'gallo_malo', 'hacker', 'trampa'];

export default function ModeratorNotifications({ messages, onRemoveMessage }) {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // Analizar los mensajes más recientes en busca de palabras prohibidas o sospechosas
    const newNotifications = [];
    messages.forEach(msg => {
      const hasForbiddenWord = FORBIDDEN_WORDS.some(word =>
        msg.content.toLowerCase().includes(word)
      );
      if (hasForbiddenWord) {
        newNotifications.push({
          id: `warn-${msg.id}`,
          type: 'warning',
          title: 'Mensaje Sospechoso Detectado',
          description: `El usuario @${msg.nickname} usó lenguaje inapropiado o palabras restringidas.`,
          message: msg,
          time: new Date(msg.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        });
      }
    });
    setNotifications(newNotifications);
  }, [messages]);

  return (
    <section className="rounded-2xl border border-white/10 bg-[#111] p-5 space-y-4 h-[550px] flex flex-col">
      <div>
        <h3 className="font-semibold text-white text-sm sm:text-base flex items-center gap-2">
          <SafeIcon icon={FiBell} className="text-red-500 animate-bounce" />
          Alertas de Moderación en Vivo
        </h3>
        <p className="text-xs text-gray-500 mt-0.5">
          Notificaciones instantáneas del sistema sobre comportamiento sospechoso o posibles reportes de usuarios.
        </p>
      </div>
      <div className="flex-1 overflow-y-auto space-y-3">
        {notifications.map((notif) => (
          <div key={notif.id} className="p-3.5 bg-red-950/10 border border-red-500/20 rounded-xl space-y-2.5">
            <div className="flex items-start justify-between gap-2">
              <div className="flex items-start gap-2.5 min-w-0">
                <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-red-600/10 text-red-500 shrink-0">
                  <SafeIcon icon={FiAlertTriangle} size={14} />
                </span>
                <div className="min-w-0">
                  <p className="text-xs font-bold text-red-400">{notif.title}</p>
                  <p className="text-[10px] text-gray-400 mt-0.5">{notif.description}</p>
                </div>
              </div>
              <span className="text-[9px] text-gray-500 shrink-0">{notif.time}</span>
            </div>
            <div className="p-2.5 bg-black/40 rounded-lg text-xs text-gray-300 italic border-l-2 border-red-600">
              "{notif.message.content}"
            </div>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => onRemoveMessage(notif.message)}
                className="flex items-center gap-1 px-2.5 py-1 bg-red-600 hover:bg-red-700 text-white font-semibold rounded text-[10px] transition-all"
              >
                <SafeIcon icon={FiTrash2} size={10} />
                Eliminar Mensaje
              </button>
            </div>
          </div>
        ))}
        {notifications.length === 0 && (
          <div className="flex flex-col items-center justify-center h-full text-center py-12">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white/5 text-gray-500 mb-3">
              <SafeIcon icon={FiUserCheck} size={20} />
            </span>
            <p className="text-xs font-semibold text-gray-400">Todo en Orden</p>
            <p className="text-[10px] text-gray-600 mt-1 max-w-[200px]">
              No se han detectado mensajes con palabras prohibidas en el chat activo.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}